/* global $ */
import React, { Component } from 'react';
import { Button, Header, Icon, Modal } from 'semantic-ui-react';

export class ConfirmReset extends Component {

    componentDidMount() {
        var self = this;
        var token = this.props.accessToken;
        $('#confirmReset').modal({
            closable  : false,
            onApprove : function() {
                alert("In window: " + token);
                self.props.reset();
            }
        })
    }

    componentWillReceiveProps() {

    }

    render() {
        return (
            <Modal
                open={this.props.resetModalOpen}
                onClose={this.props.handleResetClose}
                size='tiny'
                closeOnEscape={false}
                closeOnRootNodeClick={false}
            >
                <Modal.Content>
                    <p style={{marginTop: "20px", textAlign: "center", lineHeight: "normal"}}>
                        <i className="icon-warning" style={{fontSize: '8em', color: '#D4D4D5'}} />
                    </p>
                    <p id="innerText">
                        {this.props.showMessage('message_11_01')} <span className="purple">'{this.props.showMessage('message_11_02')}'</span> {this.props.showMessage('message_11_03')}
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Button className="ui button cancel secondary" id="cancelButton" onClick={this.props.handleResetClose}>{this.props.showMessage('message_11_04')}</Button>
                    <Button className="ui button approve primary" id="saveButton" onClick={this.props.reset}>{this.props.showMessage('message_11_02')} ></Button>
                </Modal.Actions>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/windows/ConfirmReset.jsx